import { API_JWT_BASE_URL } from '../http'

export const SEACRH_DEVICE_API = `${API_JWT_BASE_URL}/GlobalSearch`
export const GET_DEVICE_DETAIL_API = `${API_JWT_BASE_URL}/Devices/details/`
export const EXPORT_DEVICES_API = `${API_JWT_BASE_URL}/Devices/export`
export const UPDATE_DEVICE_API = `${API_JWT_BASE_URL}/Devices/`
export const DELETE_DEVICE_API = `${API_JWT_BASE_URL}/Devices`
export const CREATE_DEVICE_API = `${API_JWT_BASE_URL}/Devices`
export const GET_DEVICE_CREATION_INFO_API = `${API_JWT_BASE_URL}/Devices/getdevicecreationinfo`
export const GET_MATCHING_GROUP_DEVICE_API = `${API_JWT_BASE_URL}/Devices/othergroupsmatchingtype`
export const MOVE_TO_GROUP_API = `${API_JWT_BASE_URL}/Devices/move`
export const GET_IS_LICENSE_OTAP_API = `${API_JWT_BASE_URL}/Devices/isLicenseForOtap`
export const GET_DECOMMISSION_INFO_API = `${API_JWT_BASE_URL}/Devices/getDecommissionInfo`
export const DECOMMISSION_DEVICE_API = `${API_JWT_BASE_URL}/Devices/decommission`
export const COMMIT_DEVICE_API = `${API_JWT_BASE_URL}/Devices/CommitCustomFields`
export const IMPORT_DEVICES_API = `${API_JWT_BASE_URL}/Devices/import`
export const GET_DEVICE_OTAP_STATE_API = `${API_JWT_BASE_URL}/Devices/`

export const DEVICE_QUERY_KEYS = {
  SEACRH_DEVICE: 'searchDevice',
  GET_DEVICE_DETAIL: 'getDeviceDetail',
  EXPORT_DEVICES: 'exportDevices',
  UPDATE_DEVICE: 'updateDevice',
  DELETE_DEVICE: 'deleteDevice',
  CREATE_DEVICE: 'createDevice',
  DEVICE_CREATION_INFO: 'deviceCreationInfo',
  GET_MATCHING_GROUP_DEVICE: 'getMatchingGroupDevice',
  MOVE_TO_GROUP: 'moveToGroup',
  GET_IS_LICENSE_OTAP: 'GET_IS_LICENSE_OTAP',
  GET_DECOMMISSION_INFO: 'GET_DECOMMISSION_INFO',
  DECOMMISSION_DEVICE: 'DECOMMISSION_DEVICE',
  COMMIT_DEVICE: 'commitDevice',
  GET_DEVICE_OTAP_STATE: 'GET_DEVICE_OTAP_STATE'
}
